import PropTypes from 'prop-types';
import React from 'react';
import {Link} from 'react-router-dom';
import {
  List,
  withStyles,
} from '@material-ui/core';
import grey from '@material-ui/core/colors/grey';
import classNames from 'classnames';

import TlSubheader from 'ondemand/components/TlSubheader';

const styles = () => ({
  root: {
    padding: '0px 20px'
  },
  disabled: {
    backgroundColor: grey['200'],
  }
});

const DialogListSection = ({children, dataId, disabled = false, title, mainMenuLink, classes}) => {
  let titleComponent;
  if (mainMenuLink) {
    titleComponent = (
      <div data-id={dataId} style={{position: 'relative'}}>
        <span>{title}</span>
        <span style={{position: 'absolute', right: '0px'}}>
          <Link
            data-id={'modal-main-menu-link'}
            to={{pathname: '/rides', search: '?showMenu=1'}}
            style={{color: '#4a90e2', fontSize: 'smaller'}}
          >
            Main Menu
          </Link>
        </span>
      </div>
    );
  } else {
    titleComponent = title;
  }
  return (
    <List
      className={classNames([classes.root, {[classes.disabled]: disabled}])}
    >
      <TlSubheader style={{paddingLeft: '0px', color: grey[600]}}>{titleComponent}</TlSubheader>
        {
          React.Children.map(children, (child) =>
            React.cloneElement(child, {disabled})
          )
        }
    </List>
  );
};

DialogListSection.propTypes = {
  children: PropTypes.node,
  dataId: PropTypes.string,
  disabled: PropTypes.bool,
  title: PropTypes.node,
  mainMenuLink: PropTypes.bool,
  classes: PropTypes.object,
};

export default withStyles(styles)(DialogListSection);



// WEBPACK FOOTER //
// ./src/ondemand/components/DialogListSection.js